
/**
 * PropertyColorField - Reusable color picker field for garden object properties
 *
 * @param {string} label - Field label
 * @param {string} value - Current color value (hex)
 * @param {function} onChange - Callback(newColor) when color changes
 * @param {boolean} disabled - Whether field is disabled
 * @param {boolean} showCustomToggle - Whether to show the "Benutzerdefinierte Farbe" toggle
 * @param {boolean} useCustomColor - Whether custom color mode is active
 * @param {function} onToggleCustomColor - Callback(boolean) when toggle changes
 */
const PropertyColorField = ({
  label,
  value,
  onChange,
  disabled = false,
  showCustomToggle = false,
  useCustomColor = false,
  onToggleCustomColor,
}) => {
  const isColorDisabled = disabled || (showCustomToggle && !useCustomColor);

  return (
    <div>
      {showCustomToggle && (
        <label className="flex items-center gap-2 mb-2 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={useCustomColor}
            onChange={(e) => onToggleCustomColor?.(e.target.checked)}
            disabled={disabled}
            className="h-4 w-4 rounded border-gray-300 text-emerald-600
              focus:ring-emerald-500 disabled:opacity-50"
          />
          <span className="text-xs font-medium text-gray-600">
            Benutzerdefinierte Farbe
          </span>
        </label>
      )}
      <label className="block text-xs font-medium text-gray-600 mb-1">
        {label}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          disabled={isColorDisabled}
          className="h-10 w-16 border border-gray-300 rounded cursor-pointer
            disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={isColorDisabled}
          placeholder="#000000"
          className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded
            focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500
            disabled:bg-gray-100 disabled:cursor-not-allowed font-mono"
        />
      </div>
    </div>
  );
};

export default PropertyColorField;
